export default{
	lang:{
		title: 'Поиск электросхем авто',
		language: 'Язык',
		brand: "Марка ТС",
		carName: "Модель авто",
		searchMC: "Название системы",
		searchMS: "Описание системы",
		jumper: "ID перемычки",
		buuton1: "Поиск",
		desOption:['Проверка аккумуляторного блока','Компрессор на борту ТС','Подкузовной компрессор'],
		report:{
			shebei1: '',
			shebei2: 'Предоставлено диагностическим оборудованием',
			oneTitle: 'Результат проверки',
			ver: 'Номер ТС не указан',
			vin: 'VIN',
			bianhao: 'Номер отчета',
			jcTime: 'Дата и время проверки',
			bms: 'Результат проверки BMS',
			tips: 'Примечание',
			tipText: '«Не поддерживается» означает, что при проверке аккумуляторного блока невозможно считать данные этого параметра. Попробуйте открыть BMS (систему управления аккумуляторами) в разделе полной диагностики ТС для считывания потоковых данных.',
			soc: 'Остаточный заряд SOC',
			soh: 'Состояние здоровья АКБ SOH',
			Vname1: 'Общее напряжение',
			Vname2: 'Количество циклов заряда',
			Vname3: 'Максимальное напряжение отдельной ячейки',
			Vname4: 'Максимальная температура отдельной ячейки',
			Vname5: 'Минимальное напряжение отдельной ячейки',
			Vname6: 'Минимальная температура отдельной ячейки',
			Vname7: 'Разность напряжений',
			Vname8: 'Значение изоляционного сопротивления',
			bms: 'Детали проверки BMS',
			tab1: 'Проверяемый параметр ',
			tab2: 'Результат проверки',
			tab3: 'Ед.',
			dtdy: 'Uяч',
			max: 'Макс.',
			min: 'Мин.',
			dcwd: 'Тяч',
			shengcheng: 'Сформировать PDF',
			jcsb: 'Диагн.обор.',
			sbbh: 'Номер оборудования',
		}
	}
}